import { render, staticRenderFns } from "./VsList.vue?vue&type=template&id=46b7682e&scoped=true&"
import script from "./VsList.vue?vue&type=script&lang=js&"
export * from "./VsList.vue?vue&type=script&lang=js&"
import style0 from "./VsList.vue?vue&type=style&index=0&id=46b7682e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b7682e",
  null
  
)

export default component.exports